export default [
  [
    terms => terms,
    'Please read Terms and Conditions and Privacy policy and check to agree.',
  ],
]
